export type PffFontFamilyDEPRECATED = 'PFF Sans' | 'PFF Serif'
export type InterFontFamilyDEPRECATED = 'Inter'

export const FONT_FAMILY_SANS: PffFontFamilyDEPRECATED = 'PFF Sans'
export const FONT_FAMILY_SERIF: PffFontFamilyDEPRECATED = 'PFF Serif'
export const FONT_FAMILY_INTER: InterFontFamilyDEPRECATED = 'Inter'
